/*
 * Copyright (c) Funtip GbR 2017.
 * Simon Oldeboershuis, Perry Prust
 */

import { actionCreatorFactory } from 'typescript-fsa';

const actionCreator = actionCreatorFactory();

export const RANKING_LOAD_WITHOUT_PROPS = 'RANKING_LOAD_WITHOUT_PROPS';
export const rankingLoadWithoutProps = actionCreator(RANKING_LOAD_WITHOUT_PROPS);
